import { Controller } from 'stimulus'

// The "Label settings" modal opened from the Print Labels size popup (see
// shared/sample_labels/_settings_modal): show/hide of the modal target, plus
// a name filter over the trait checklist when it's long. The form inside
// posts normally and the page reloads with a flash.
export default class extends Controller {
  static targets = ['modal', 'search', 'item', 'empty']

  open(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.remove('hidden')
    if (this.hasSearchTarget) {
      this.searchTarget.value = ''
      this.filter()
      setTimeout(() => this.searchTarget.focus(), 0)
    }
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add('hidden')
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }

  filter() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ''
    let visible = 0
    this.itemTargets.forEach((item) => {
      const match = !query || (item.dataset.name || '').indexOf(query) !== -1
      item.classList.toggle('hidden', !match)
      if (match) visible += 1
    })
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle('hidden', visible !== 0)
  }
}
